import { SELECTED_COUNTRY_KEY } from "../CountryContext";

const getRoutePath = (path) => {
  if (!localStorage.getItem(SELECTED_COUNTRY_KEY)) {
    return "/";
  }

  return `/${localStorage.getItem(SELECTED_COUNTRY_KEY)}${path}`;
};

export default getRoutePath;
